<template>
  <div class="page-main">
    <!-- 表格操作条 -->
    <vxe-toolbar ref="refToolbar" size="mini" :loading="loading">
      <template #buttons>
        <!-- <el-button type="success" size="mini" @click="itemPass">审核通过</el-button> -->
        <!-- <el-button type="danger" size="mini" @click="itemReject">审核拒绝</el-button> -->
        <el-button type="primary" size="mini" @click="itemPayout">开付款单</el-button>
      </template>
    </vxe-toolbar>

    <!-- 表格 -->
    <vxe-grid
      ref="refTable"
      show-footer
      :loading="loading"
      :columns="tableColumn"
      :data="tableData"
      :height="this.$util.getViewHeight() - 36 - 148"
      :export-config="{ type: ['xlsx'], types: ['xlsx'] }"
      :keyboard-config="{ isArrow: true }"
      :footer-method="footerMethod"
      :merge-cells="mergeCell"
      @keydown="tableKeydown"
      @current-change="tableCurrentChange"
    >
      <!-- slot_header -->
      <template #header_input="{ column }">
        <c-table-header
          :title="column.title"
          :field="column.field"
          :url="headerFilterUrl"
          @change="headerFilterChange"
        />
      </template>

      <!-- slot_default -->
      <template #default_cai_gou_code="{ row }">
        <el-link type="primary" @click="itemPrint(row)"> {{ row.cai_gou_code }} </el-link>
      </template>
      <template #default_fu_kuan_status="{ row }">
        <span v-if="row.fu_kuan_status === '欠款'" :style="{ color: '#f45' }">
          {{ row.fu_kuan_status }}
        </span>
        <span v-if="row.fu_kuan_status === '已结清'" :style="{ color: '#67c23a' }">
          {{ row.fu_kuan_status }}
        </span>
      </template>
      <template #default_fu_kuan_ji_lu="{ row }">
        <el-link v-if="row.sum_shi_fu_money" type="primary" @click="itemFuKuanDetail(row)">
          查看
        </el-link>
      </template>

      <!-- slot_pager -->
      <template #pager>
        <div></div>
        <vxe-pager v-bind="pageOptions" @page-change="pageChange" />
      </template>
    </vxe-grid>

    <!-- 弹窗-开付款单 -->
    <PopupFk
      v-if="isShowPopupFk"
      :show.sync="isShowPopupFk"
      :caiGouBillId="activeObj.cai_gou_bill_id"
      @success="searchListData"
    />

    <!-- 弹窗-查看付款 -->
    <PopupCkfk
      v-if="isShowPopupCkfk"
      :show.sync="isShowPopupCkfk"
      :caiGouBillId="activeObj.cai_gou_bill_id"
    />
  </div>
</template>

<script>
export default {
  components: {
    PopupFk: () => import('../../../common/popup-fk'),
    PopupCkfk: () => import('../../../common/popup-ckfk')
  },
  data() {
    return {
      loading: true,

      // filter
      filterData: {},
      sortData: {
        cai_gou_bill_id: 'desc'
      },

      // table
      headerFilterUrl: '/admin/gcvip/caigou/searchHeardByCaiWu',
      mergeCell: [],
      tableData: [],
      tableColumn: [
        {
          fixed: 'left',
          type: 'radio',
          isMerge: true,
          width: 40
        },
        {
          fixed: 'left',
          title: '序号',
          type: 'seq',
          isMerge: true,
          width: 40
        },
        {
          title: '采购单号',
          field: 'cai_gou_code',
          width: 110,
          isMerge: true,
          slots: { header: 'header_input', default: 'default_cai_gou_code' }
        },
        {
          title: '供应商',
          field: 'supplier_company_name',
          isMerge: true,
          slots: { header: 'header_input' }
        },
        {
          title: '应付金额(元)',
          field: 'sum_cai_gou_stock_amount',
          isMerge: true,
          slots: { header: 'header_input' }
        },
        {
          title: '已付金额(元)',
          field: 'sum_shi_fu_money',
          isMerge: true,
          slots: { header: 'header_input' }
        },
        {
          title: '欠款金额(元)',
          field: 'qian_kuan_money',
          isMerge: true,
          slots: { header: 'header_input' }
        },
        {
          title: '付款状态',
          field: 'fu_kuan_status',
          isMerge: true,
          slots: { header: 'header_input', default: 'default_fu_kuan_status' }
        },
        {
          title: '付款记录',
          isMerge: true,
          slots: { default: 'default_fu_kuan_ji_lu' }
        }
      ],
      pageOptions: {
        ...this.$constant.page
      },
      totalObj: {
        sum_cai_gou_stock_amount_all: '',
        sum_shi_fu_money_all: '',
        qian_kuan_money_all: ''
      },

      isShowPopupFk: false, // 是否显示开付款单
      isShowPopupCkfk: false, // 是否显示查看付款
      activeObj: ''
    }
  },
  mounted() {
    this.getListData()
    this.$nextTick(() => {
      this.$refs.refTable.connect(this.$refs.refToolbar) // 手动将表格和工具栏进行关联
    })
  },
  methods: {
    // 头部筛选更新
    headerFilterChange(obj) {
      this.filterData[obj.field] = obj.value
      this.searchListData()
    },
    // 搜索列表数据
    searchListData() {
      this.pageOptions.currentPage = 1
      this.getListData()
    },
    // 获取列表数据
    getListData() {
      this.loading = true
      this.$api({
        method: 'post',
        url: '/admin/gcvip/caigou/listByCaiWu',
        data: {
          currentPage: this.pageOptions.currentPage,
          pageSize: this.pageOptions.pageSize,
          filterData: this.filterData,
          sortData: this.sortData
        }
      })
        .then((res) => {
          if (res.data.state === 'ok') {
            let data = res.data.page
            this.tableData = data.list
            this.pageOptions.pageSize = data.pageSize
            this.pageOptions.total = data.totalRow
            this.pageOptions.currentPage = data.pageNumber
            this.totalObj.sum_cai_gou_stock_amount_all = res.data.sum_cai_gou_stock_amount_all
            this.totalObj.sum_shi_fu_money_all = res.data.sum_shi_fu_money_all
            this.totalObj.qian_kuan_money_all = res.data.qian_kuan_money_all
            this.mergeCell = this.$tool.getMergeCellConfigList(
              this.tableData,
              this.tableColumn,
              'id1'
            )
          }
        })
        .catch(() => {})
        .then(() => {
          this.loading = false
        })
    },
    // 分页切换
    pageChange({ currentPage, pageSize }) {
      this.pageOptions.currentPage = currentPage
      this.pageOptions.pageSize = pageSize
      this.getListData()
    },
    // 表格底部
    footerMethod({ columns }) {
      return [
        columns.map((column, columnIndex) => {
          if (columnIndex === 0) return '合计'
          if (column.field === 'sum_cai_gou_stock_amount')
            return this.totalObj.sum_cai_gou_stock_amount_all
          if (column.field === 'sum_shi_fu_money') return this.totalObj.sum_shi_fu_money_all
          if (column.field === 'qian_kuan_money') return this.totalObj.qian_kuan_money_all
        })
      ]
    },
    // 获取-当前单选行
    getRadioRecord() {
      return this.$refs.refTable.getRadioRecord()
    },
    // 表格-高亮行更改
    tableCurrentChange(params) {
      this.$refs.refTable.setRadioRow(params.row, true) // 选中radio
    },
    // 表格-键盘空格
    tableKeydown(params) {
      if (params.$event.code === 'Space') {
        let row = this.$refs.refTable.getCurrentRecord()
        let isCurrentRowRadio = this.$refs.refTable.isCheckedByRadioRow(row)
        if (isCurrentRowRadio) {
          this.$refs.refTable.clearRadioRow() // 清空radio
        } else {
          this.$refs.refTable.setRadioRow(row) // 选中radio
        }
      }
    },
    // 项-选择提示
    itemChoosePrompt() {
      this.$tool.tableChoosePrompt()
    },
    // 项-查看付款记录
    itemFuKuanDetail(row) {
      this.activeObj = row
      this.isShowPopupCkfk = true
    },
    // 项-打印
    itemPrint(row) {
      window.open(`/purchase/order/print?code=${row.cai_gou_code}`, '_blank')
    },
    // 项-开付款单
    itemPayout() {
      let row = this.getRadioRecord()
      if (row) {
        this.itemPayoutAction(row)
      } else {
        this.itemChoosePrompt()
      }
    },
    // 项-开付款单
    itemPayoutAction(row) {
      this.activeObj = row
      this.isShowPopupFk = true
    }
  }
}
</script>

<style lang="less" scoped>
.page-main {
}
</style>
